import { axiosInstance, baseUrl, handleErrors } from './auth'

export const VENDOR_LIST = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/vendorList`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const ADD_VENDOR = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/addVendor`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const UPDATE_VENDOR = async (params) => {
  try {
    const response = await axiosInstance.put(`${baseUrl}/vendor/updateVendor`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const DELETE_VENDOR = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/toggleDeleteVendor`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const CHANGE_STATUS_VENDOR = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/toggleStatusVendor`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const RESEND_INVITATION = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/sendInviteAgain`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const GET_VENDOR_DETAILS = async (params) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/vendor/${params}`)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const VENDOR_DELETE_ACCOUNT = async (params) => {
  try {
    const response = await axiosInstance.put(`${baseUrl}/vendor/deleteVendor`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}

// team member

export const TEAM_MEMBER_LIST = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/memberList`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const ADD_TEAM_MEMBER = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/addMember`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const UPDATE_TEAM_MEMBER = async (params) => {
  try {
    const response = await axiosInstance.put(`${baseUrl}/vendor/updateMember`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
// designation

export const ADD_DESIGNATION = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/addDesignation`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const UPDATE_DESIGNATION = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/updateDesignation`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const DESIGNATION_LIST = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/listDesignation`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const DELETE_DESIGNATION = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/designation/toggleDelete`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const CHANGE_STATUS_DESIGNATION = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/designation/toggleStatus`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}

export const DELETE_TEAM_MEMBER = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/toggleDeleteUser`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const CHANGE_STATUS_TEAM_MEMBER = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/toggleStatusUser`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
// location

export const LOCATION_LIST = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/locationList`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const ADD_LOCATION = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/addLocation`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const UPDATE_LOCATION = async (params) => {
  try {
    const response = await axiosInstance.put(`${baseUrl}/vendor/updateLocation`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}

export const DELETE_VENDOR_LOCATION = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/toggleDeleteVendorLocation`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const CHANGE_STATUS_VENDOR_LOCATION = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/toggleStatusVendorLocation`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const MARK_DEFAULT = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/markDefault`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}

// category

export const CATEGORY_LIST = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/category/list`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const ADD_CATEGORY = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/category`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}

export const GET_CATEGORY = async (params) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/category/${params}`)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}

export const UPDATE_CATEGORY = async (params) => {
  try {
    const response = await axiosInstance.put(`${baseUrl}/category`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}

export const DELETE_CATEGORY = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/category/toggleDelete`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const CHANGE_CATEGORY_STATUS = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/category/toggleStatus`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}

// services

export const SERVICE_LIST = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/serviceList`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const ADD_SERVICE = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/addService`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const UPDATE_SERVICE = async (params) => {
  try {
    const response = await axiosInstance.put(`${baseUrl}/vendor/updateService`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}

export const DELETE_VENDOR_SERVICE = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/toggleDeleteVendorServiceModel`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const CHANGE_STATUS_VENDOR_SERVICE = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/toggleStatusVendorServiceModel`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}

// combos

export const COMBOS_LIST = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/combo/list`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const ADD_COMBOS = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/combo`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const UPDATE_COMBOS = async (params) => {
  try {
    const response = await axiosInstance.put(`${baseUrl}/combo`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}

export const DELETE_COMBOS = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/combo/toggleDelete`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const CHANGE_STATUS_COMBOS = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/combo/toggleStatus`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const SUb_BUSINESS_CATEGORY_LIST = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/subCategory/subCategoryList`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const BUSINESS_CATEGORY_LIST = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/business/categoryListVendor`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
// business/categoryListVendor

//*******************************   BOOKING LIST SECTION************************ */

export const BOOKING_LIST = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/client/bookingList`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const EVENT_BOOKING_LIST = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/client/ticket/bookingList`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const CALENDER_LIST = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/booking/calendarData`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}

export const BLOCK_CALENDAR = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/blockCalendar`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const BLOCK_CALENDAR_LIST = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/listBlockCalendar`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
export const DELETE_BLOCK = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/vendor/toggleDeleteCalendar`, params)
    return response.data
  } catch (error) {
    handleErrors(error)
  }
}
